var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dsf-ac-style-coursebox" },
    [
      _c("grid", {
        ref: "dsfDatagrid",
        staticStyle: { height: "100%" },
        attrs: {
          demo: _vm.demo,
          hasLoad: _vm.hasLoad,
          hasRefresh: _vm.hasRefresh,
          "http-param": _vm.childform,
          "background-color": "#fff",
          limit: _vm.limit,
          padding: _vm.padding,
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (sditem) {
              return _c("div", { key: sditem.data._id }, [
                _c(
                  "div",
                  {
                    staticClass: "citem",
                    on: {
                      click: function ($event) {
                        return _vm.tocou(sditem.data._id)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "imgbox" },
                      [
                        _c("van-image", {
                          attrs: {
                            src: _vm.setImg(sditem.data),
                            fit: "full",
                            width: "100%",
                            height: "100%",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "loading",
                                fn: function () {
                                  return [
                                    _c("van-loading", {
                                      attrs: { type: "spinner", size: "20" },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "error",
                                fn: function () {
                                  return [
                                    _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                      },
                                      attrs: {
                                        src: require("_teas/assets/styles/themes/img/file-read-18688.png"),
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("div", { staticClass: "tnum ds_font8" }, [
                          _c("i"),
                          _c("span", [
                            _vm._v(
                              _vm._s(sditem.data["nc_kck_zxkc_zxkcsjy.kcsc"])
                            ),
                          ]),
                        ]),
                        _c("h6"),
                        _c("h5", [
                          _vm._v(
                            _vm._s(sditem.data["nc_kck_zxkc_zxkcsjy.kcfs"])
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "rcontent" }, [
                      _c("div", { staticClass: "toptitle ds_font5_m" }, [
                        sditem.data["nc_kck_zxkc_zxkcsjy.sfnew"] == 1
                          ? _c("span", { staticClass: "s1 ds_font8" }, [
                              _vm._v("new"),
                            ])
                          : _vm._e(),
                        sditem.data["nc_kck_zxkc_zxkcsjy.sfbx"] == 1
                          ? _c("span", { staticClass: "s2 ds_font6" }, [
                              _vm._v("必修"),
                            ])
                          : _vm._e(),
                        _c("p", { staticClass: "ell2" }, [
                          _vm._v(
                            _vm._s(sditem.data["nc_kck_zxkc_zxkcsjy.title"])
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "cencontent ds_font8 ell" }, [
                        _vm._v(
                          " " +
                            _vm._s(sditem.data["nc_kck_zxkc_zxkcsjy.skjs"]) +
                            " "
                        ),
                      ]),
                      _c("div", { staticClass: "footnum ds_font8" }, [
                        _c(
                          "p",
                          { staticClass: "p1" },
                          [
                            _c("dsf-icon", { attrs: { name: "icon_yulan" } }),
                            _c("span", [
                              _vm._v(
                                _vm._s(sditem.data["nc_kck_zxkc_zxkcsjy.ckl"])
                              ),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "p",
                          { staticClass: "p2" },
                          [
                            _c("dsf-icon", { attrs: { name: "date" } }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  sditem.data["nc_kck_zxkc_zxkcsjy.kcxs"]
                                ) + "学时"
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "rechart" },
                        [
                          _c("van-circle", {
                            attrs: {
                              value: _vm.recharNum(sditem.data),
                              text: sditem.data["nc_kck_zxkc_zxkcsjy.wcjd"],
                              "layer-color": "#D8D8D8",
                              color: "#FF6A00",
                              rate: sditem.data["nc_kck_zxkc_zxkcsjy.wcjd"],
                              speed: 30,
                              size: _vm.pxToRem("35px"),
                              "stroke-width": 100,
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }